import React, { useState } from "react";
import { Typography, Box, Link } from "@mui/material";
import { Container } from "./banner.styles";
import { AppSpecificMsg, AppSpecificList } from "constants/headerImage";
import Help from "../../../shared/help";

function Banner() {
  const [open, setOpen] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  let app: string = queryParams.get("app") ?? "BRP";
  app = app.toUpperCase();
  localStorage.setItem("appname", app.toUpperCase());

  const appName:any = localStorage.getItem('appname');

  return (
    <Container>
      
    {/* <Typography variant="h2" color="secondary">
     {AppSpecificMsg[appName]}
    </Typography>  */}


    <Box
      sx={{
        background: 'linear-gradient(to bottom, #ffffff, #e1f6fe)',
        width: '100%',
        boxSizing: 'border-box',
        padding: '16px',
      }}
    >
      {/* Logo and Help Link */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '24px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <img
            src={AppSpecificList[app]}
            alt="Bayer Rewards Logo"
            style={{
              width: 'auto',
              maxWidth: '170px',
              objectFit: 'contain',
              mixBlendMode: 'multiply',
              height: '50px',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              left: '0px',
              bottom: '-8px',
              width: '24px',
              height: '2px',
              backgroundColor: '#0eb5ec',
              borderRadius: '4px',
            }}
          />
        </Box>
        <Link
          href="#"
          onClick={(event) => {
            event.preventDefault();
            setOpen(true);
          }}
          underline="none"
          sx={{
            color: '#007cbf',
            fontSize: '16px',
            fontWeight: 600,
            fontFamily: 'Noto Sans, sans-serif',
          }}
        >
          Need Help?
        </Link>
      </Box>

      {/* Title */}
      <Typography
        variant="h5"
        sx={{
          fontSize: '20px',
          fontWeight: 600,
          color: 'rgba(0,0,0,0.87)',
          fontFamily: 'Noto Sans, sans-serif',
          letterSpacing: '0.15px',
          lineHeight: 1.6,
        }}
      >
        {AppSpecificMsg[appName]}
      </Typography>
    </Box>
      
      {/* <Typography sx={{ pt: 1 }} variant="h3" color="secondary">
        {t("proceed", {
          defaultValue:
            "Please proceed with OTP verification to start the KYC process",
        })}
      </Typography> */}
      <Help open={open} close={setOpen} />
    </Container>
  );
}

export default Banner;
